export const action_types = {
  REQUEST_QRCODE: 'REQUEST_QRCODE',
  SUCCESS_QRCODE: 'SUCCESS_QRCODE',
  ERROR_QRCODE: 'ERROR_QRCODE',
  REQUEST_REDEEM_HANDLE: 'REQUEST_REDEEM_HANDLE',
  SUCCESS_REDEEM_HANDLE: 'SUCCESS_REDEEM_HANDLE',
  ERROR_REDEEM_HANDLE: 'ERROR_REDEEM_HANDLE',
  ACTIVE_PROMOTION_COUPON: 'ACTIVE_PROMOTION_COUPON',
  RESET_REDEEM: 'RESET_REDEEM',
}